<template>
 <h3>细分券池</h3>
  <StockSearchForm @submit="fetchData" :isSubmitting="isSubmitting" />
   <div class="container"  :style="{ display: containerDisplay ? 'block' : 'none' }">
    <div>{{ warring }}</div>
  </div>
  <div>
  <div class="filter-group">
  <el-radio-group v-model="selectedStructure" @change="applyFilter" v-if="tableData.length > 0">
    <div class="filter-title">类型：</div>
    <el-radio-button
      v-for="option in options"
      :key="option.value"
      :label="option.value"
    >{{ option.label }}</el-radio-button>
  </el-radio-group>
  </div>

    <div v-if="filteredTableData.length > 0">
      <XfqcStockTable :tableData="filteredTableData" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import StockSearchForm from '@/components/StockSearchForm.vue';
import XfqcStockTable from '@/components/XfqcStockTable.vue';

export default {
  name: 'SegmentedSearchFormPage',
  components: {
    StockSearchForm,
    XfqcStockTable
  },
  data() {
    return {
      isSubmitting: false,
      searchQuery: '',
      warring: '',
      tableData: [],
      originalTableData: [],  // 添加原始数据副本
      selectedStructure: '100%',
      selectedStructure_amount: '1',
      selectedBrokerage: 'all',  // 初始化为默认值
      selectedTimes:'1M',
      options: [
        { value: '80%', label: '80%' },
        { value: '90%', label: '90%' },
        { value: '95%', label: '95%' },
        { value: '100%', label: '100%' },
        { value: '103%', label: '103%' },
        { value: '105%', label: '105%' },
        { value: '110%', label: '110%' }
      ],

      total_principal: '1',  // 初始化为默认值
      total_principal_label: '100w',  // 用于存储 label 值
      containerDisplay:false,
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalRecords / this.perPage);
    },
    filteredTableData() {

      let filteredData = this.tableData;
      console.log(this.tableData);
      return filteredData;

    }
  },
  methods: {
    applyPrice() {
      // 根据 selectedStructure_amount 计算倍数
      const selectedOption = this.total_principal_options.find(option => option.value === this.selectedStructure_amount);
      this.total_principal = selectedOption.value;
      this.total_principal_label = selectedOption.label;  // 直接使用 this.total_principal_label
    },
    async fetchData(searchQuery) {
      if (this.isSubmitting) return;
      console.log('开始请求数据:', searchQuery);
      this.isSubmitting = true;
      try {
        const response = await axios.get(`/api/query_xfqc?code=${searchQuery}`,{
             headers: {
                 'Authorization': `Bearer ${this.$store.getters.token}`
             },

        });
        const responseData = response.data;
        if (responseData.data == null) {
          this.warring = '没有找到相关数据，请检查输入的股票代码是否是两融标的。';
          this.data = {};
          this.tableData = [];
          this.containerDisplay = true;
        } else {
          this.data = responseData;
          console.log('got data:', this.data);
          this.generateTableData();
          this.containerDisplay = false;
        }
      } catch (error) {
        this.warring = '数据获取失败，' + this.data.error;
      } finally {
        this.isSubmitting = false;
        console.log('请求完成');
      }
    },
   generateTableData() {
       this.tableData = this.data.data['国君_总券池'];
   },
   applyBrokerageFilter() {
      // 这个方法在 computed 中的 filteredTableData 已经处理了
    }
  }
}
</script>
<style>
.filter-group {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.el-radio-group {
  display: flex;
  align-items: center;
  background: #f5f7fa;
  border-radius: 4px;
  padding: 8px 10px;
}

.filter-title {
  margin-right: 10px;
  font-size: 14px;
  color: #606266;
}

.el-radio-button {
  margin-left: 8px;
}

.el-radio-button:first-child {
  margin-left: 0;
}

.el-radio-button__inner {
  padding: 8px 15px;
}

</style>